import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { Nominal, RegularBenefitVariant } from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuiteNominal(intl: IntlShape) {
  return create(({ value, type }: Nominal) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.Nominal, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })
    })
  })
}
